import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import ChooseManufacturerModalView from './ChooseManufacturerModalView';

interface IProps {
  isModalOpen: boolean;
  importId: number;
  setIsUnknownManufactures: Dispatch<SetStateAction<boolean>>;
  refetchColumns;
}

const ChooseManufacturerModal = ({
  isModalOpen,
  importId,
  refetchColumns,
  setIsUnknownManufactures,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(isModalOpen);
  }, [isModalOpen]);

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <ChooseManufacturerModalView
      isOpen={isOpen}
      onClose={onClose}
      importId={importId}
      isModalOpen={isModalOpen}
      refetchColumns={refetchColumns}
      setIsUnknownManufactures={setIsUnknownManufactures}
    />
  );
};

export default ChooseManufacturerModal;
